import { render, staticRenderFns } from "./error-layout.vue?vue&type=template&id=40557c9e&scoped=true&"
import script from "./error-layout.vue?vue&type=script&lang=js&"
export * from "./error-layout.vue?vue&type=script&lang=js&"
import style0 from "./error-layout.vue?vue&type=style&index=0&id=40557c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40557c9e",
  null
  
)

export default component.exports